import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useDeleteAdUnit = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteAdUnit = async (id, callback) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axiosService.delete(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-ad-unit-service/v1/delete/${id}`
      );

      if (!response.ok) {
        throw new Error(`Failed to delete ad unit (status ${response.status})`);
      }

      const json = response?.data;
      callback(true);
      return json.success; // Return success status from the response
    } catch (err) {
      console.error(err);
      setError(err.message || 'An error occurred while deleting the ad unit');
      return false; // Return false if an error occurs
    } finally {
      setIsLoading(false);
    }
  };

  return [ deleteAdUnit, isLoading, error ];
};